<!-- Contenido dinámico -->
<div class="content paragraph-01-regular">
  <div id="notErrorContainer">
    <!---------- Inputs ---------->
    <div id="inputsContainer">
      <div class="inputLabelContainer">
        <label class="subheading-01-bold" for="currentPasswordInput"
          >Clave actual</label
        >
        <qr-input
          name="currentPasswordInput"
          [config]="currentPasswordConfig"
          (valueChange)="currentPasswordChange($event)"
        ></qr-input>
      </div>
      <div class="inputLabelContainer">
        <label class="subheading-01-bold" for="newPasswordInput"
          >Nueva clave</label
        >
        <qr-input
          name="newPasswordInput"
          [config]="newPasswordConfig"
          (valueChange)="newPasswordChange($event)"
        ></qr-input>
      </div>
      <div class="inputLabelContainer">
        <label class="subheading-01-bold" for="repeatPasswordInput"
          >Repetir clave</label
        >
        <qr-input
          name="repeatPasswordInput"
          [config]="repeatPasswordConfig"
          (valueChange)="repeatPasswordChange($event)"
        ></qr-input>
      </div>
    </div>
    <!---------- Conditions ---------->
    <div id="requirementsContainer">
      <div id="title" class="subheading-01-bold">Condiciones a cumplir:</div>
      <div
        class="conditions"
        [ngClass]="{ error: this.errors['length'].error }"
      >
        Entre 8 y 12 caracteres
      </div>
      <div class="conditions" [ngClass]="{ error: this.errors['caps'].error }">
        1 letra mayúscula
      </div>
      <div
        class="conditions"
        [ngClass]="{ error: this.errors['number'].error }"
      >
        1 número
      </div>
      <div
        class="conditions"
        [ngClass]="{ error: this.errors['specChar'].error }"
      >
        Sin caracteres especiales
      </div>
      <div
        class="conditions"
        [ngClass]="{ error: this.errors['userSimilar'].error }"
      >
        Distinta al usuario
      </div>
    </div>
  </div>
  <!---------- Errors ---------->
  <!-- <div id="errorContainer">
    <label class="subheading-01-semi-bold error-message" for="notSimilar">
      {{
        this.errors["notSimilar"].error ? this.errors["notSimilar"].message : ""
      }}
    </label>
  </div> -->
</div>

<!-- Botones -->
<!-- <div class="botbar">
  <div class="botbar-actions">
    <qr-button
      [config]="buttonSubmitConfig"
      (click)="save()"
      class="button-cancel"
    ></qr-button>
  </div>
</div> -->
